export const API_ENDPOINT: any = [];

export const ERROR_OBJECTS: Object = {
  required: '{{field}} is required',
  email: 'Please enter valid email'
};
